/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { OrganizationStrictHttpResponse } from '../../organization-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OrganizationCleanupSummary } from '../../models/organization-cleanup-summary';

export interface AdminFhirCleanupOrganizationSummaryFhirIdGet$Params {
  fhirId: string;
}

export function adminFhirCleanupOrganizationSummaryFhirIdGet(http: HttpClient, rootUrl: string, params: AdminFhirCleanupOrganizationSummaryFhirIdGet$Params, context?: HttpContext): Observable<OrganizationStrictHttpResponse<OrganizationCleanupSummary>> {
  const rb = new RequestBuilder(rootUrl, adminFhirCleanupOrganizationSummaryFhirIdGet.PATH, 'get');
  if (params) {
    rb.path('fhirId', params.fhirId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as OrganizationStrictHttpResponse<OrganizationCleanupSummary>;
    })
  );
}

adminFhirCleanupOrganizationSummaryFhirIdGet.PATH = '/Admin/fhir-cleanup/organization-summary/{fhirId}';
